"use strict";Object.defineProperty(exports, "__esModule", {value: true});

var _7O4F7UYXcjs = require('../__chunks/7O4F7UYX.cjs');


var _AVNURAH2cjs = require('../__chunks/AVNURAH2.cjs');
require('../__chunks/O7FALLU5.cjs');
require('../__chunks/MLKK6UGO.cjs');
require('../__chunks/WU47XUXM.cjs');
require('../__chunks/OJZKTJL7.cjs');
require('../__chunks/MMSR5JSJ.cjs');
require('../__chunks/EV33XSIB.cjs');
require('../__chunks/6P52IAFY.cjs');
require('../__chunks/PFM4PJSG.cjs');
require('../__chunks/SARAALGA.cjs');
require('../__chunks/UCZW3OGH.cjs');
require('../__chunks/FH6HQ5JN.cjs');
require('../__chunks/XWMMMXUK.cjs');
require('../__chunks/PTOCUU2D.cjs');
require('../__chunks/3BSDKDKD.cjs');
require('../__chunks/XMDZRF6Y.cjs');

// src/select/select-provider.tsx
var _jsxruntime = require('react/jsx-runtime');
function SelectProvider(props = {}) {
  const store = _7O4F7UYXcjs.useSelectStore.call(void 0, props);
  return /* @__PURE__ */ _jsxruntime.jsx.call(void 0, _AVNURAH2cjs.SelectContextProvider, { value: store, children: props.children });
}


exports.SelectProvider = SelectProvider;
